import React from 'react';
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
import type { Store } from 'redux';
import type PlanProgramType from '@jira/spa-apps__advanced-roadmaps-plan-program/src/PlanProgram.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyPlanProgram: LazyComponent<({ store }: { store: Store }) => React.JSX.Element> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PlanProgramType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-plan-program", jiraSpaEntry: "async-plan-program" */ '@jira/spa-apps__advanced-roadmaps-plan-program/src/PlanProgram.tsx'
				),
			),
		{ ssr: false },
	);

export const PlanProgram = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanProgram} pageId="plan-program" shouldShowSpinner />
);
